<template>
  <div>

    <el-dropdown :hide-on-click="false">
      <div class="notification__item red">
        <el-badge :value="supportNotificationCount" :hidden="supportNotificationCount === 0" class="item">
          <el-button size="small">
            <!-- <font-awesome-icon icon="user-circle"/> -->
            <img src="@/assets/img/toolbar/user.svg" width="18px" alt="">
          </el-button>
        </el-badge>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-if="companyLayout.permission.companySettings">
          <div @click="openSettings()">Org Settings</div>
        </el-dropdown-item>
        <el-dropdown-item>
          <div @click="myProfile">{{$t('header_settings_account')}}</div>
        </el-dropdown-item>
        <!-- <el-dropdown-item>
          <div @click="mySettings">{{$t('header_settings_settings')}}</div>
        </el-dropdown-item> -->
        <!--<el-dropdown-item>-->
          <!--<router-link :to="`/permissions?companyId=${this.$route.query.companyId}`">-->
            <!--<el-dropdown-item class="link">Permissions</div>-->
          <!--</router-link>-->
        <!--</el-dropdown-item>-->
        <el-dropdown-item>
          <el-badge :value="supportNotificationCount" :hidden="supportNotificationCount === 0" class="item">
            <div @click="openFeedback()">{{$t('header_settings_support')}}</div>
          </el-badge>
        </el-dropdown-item>
        <el-dropdown-item>
          <div @click="$refs.confirmation.open()">{{$t('header_settings_logout')}}</div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- [ Modal form Feedback Reports ] start -->
    <sweet-modal blocking :title="$t('modal_support_feedback')" ref="feedbackReports" class="modal" v-on:close="closeModal">

      <el-radio-group v-model="radio">
        <el-radio :label="1">Current</el-radio>
        <el-radio :label="2">Archive</el-radio>
      </el-radio-group>

      <el-table
        :data="tableData"
        style="width: 100%"
        :empty-text="$t('general_noData')"
        @row-click="rowClick">
        <el-table-column
          :label="$t('modal_support_feedback_number')"
          prop="id"
          width="80px">
        </el-table-column>
        <el-table-column
          :label="$t('modal_support_feedback_subject')">
          <template slot-scope="scope">
            <div v-html="scope.row.subject"></div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('modal_support_feedback_type')">
          <template slot-scope="scope">
            <div v-if="scope.row.subjectType === 1">{{$t('modal_support_feedback_type_feedback')}}</div>
            <div v-else-if="scope.row.subjectType === 2">{{$t('modal_support_feedback_type_error')}}</div>
            <div v-else-if="scope.row.subjectType === 3">{{$t('modal_support_feedback_type_help')}}</div>
            <div v-else-if="scope.row.subjectType === 4">{{$t('modal_support_feedback_type_generalEnquiries')}}</div>
            <div v-else-if="scope.row.subjectType === 5">{{$t('modal_support_feedback_type_accountingIssues')}}</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('modal_support_feedback_status')"
          width="150px">
          <template slot-scope="scope">
            <el-tag>{{scope.row.statusName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('modal_support_feedback_dateTime')" width="180px">
          <template slot-scope="scope">
            <span v-if="scope.row.createDate">
              {{moment(scope.row.createDate * 1000).format("D MMM YY / h:mm a")}}
            </span>
            <span v-else></span>
          </template>
        </el-table-column>
      </el-table>

      <el-row type="flex" justify="center" style="margin-top: 20px;">
        <el-col :span="12" style="text-align: center;">
          <el-pagination
            :current-page.sync="page"
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :page-size="10"
            :total="total">
          </el-pagination>
        </el-col>
      </el-row>

    </sweet-modal>
    <!-- [ Modal form Feedback Reports ] end -->

    <sweet-modal blocking title="Info" ref="info" width="50%">
      <div v-html="item.message" class="img"></div>
    </sweet-modal>

    <!-- [ Modal logout confirmation ] start -->
    <sweet-modal blocking :title="$t('modal_logout')" class="modal" ref="confirmation">
      {{$t('modal_logout_text')}}
      <!-- <template slot="box-action">
        <el-button class="button" @click="exit">Logout</el-button> &nbsp;
      </template> -->

      <div class="modal__btn">
        <el-button @click="modalCancel('confirmation')">{{$t('general_cancel')}}</el-button>
        <el-button @click="exit" type="primary">{{$t('general_submit')}}</el-button>
      </div>
    </sweet-modal>
    <!-- [ Modal logout confirmation ] end -->

  </div>
</template>

<script>
import log from '@/log/log.js'
import axios from 'axios'
import moment from 'moment'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  components: {
    SweetModal,
  },
  props: {
    supportNotificationCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tableData: [],
      moment:moment,

      item: {
        message: '',
        subject: ''
      },

      radio: 1,
      page: 1,
      total: 0
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    companyLayout() {
      return this.$store.state.companyLayout
    },
  },
  watch: {
    radio: function (val) {
      this.page = 1
      this.loadList()
    },
  },
  methods: {
    rowClick(row) {
      // eslint-disable-next-line no-console
      console.log('---ROW', row)
      this.item.message = row.message
      this.item.subject = row.subject
      this.$refs.info.open()
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    exit() {

      // Log logout
      log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
        'action': 'log_logout',
        'paramsLog': {}
      })

      this.$socket.close();
      // localStorage.clear()
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('vue-session-key');
      sessionStorage.removeItem('timer');
      localStorage.removeItem('selectedProjectId');
      // localStorage.removeItem('companyName')
      localStorage.removeItem('companyId');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      console.log('this.$route.fullPath', this.$route.fullPath);
      console.log('this.$route', this.$route);
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/auth/logout`)
        .then(response => {

        })
        .catch(error => {

        })
    },
    // openFeedbackReports() {
    //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    //   axios.post(`/api/v1/feedback/list?companyId=${this.$route.query.companyId}`)
    //     .then(response => {
    //       console.log('---/feedback/list', response.data.list);
    //       this.tableData = response.data.list
    //       this.$refs['feedbackReports'].open()
    //     })
    //     .catch(error => {
    //       console.log('An error occurred:', error);
    //     })
    // },
    mySettings() {
      this.$router.push({ name: 'settings', query: { companyId: this.$route.query.companyId } })

      // Log settings
      log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
        'action': 'log_settings',
        'paramsLog': {}
      })
    },
    openSettings() {
      this.$router.push({ name: 'settings-dashboard', query: { companyId: this.$route.query.companyId} } )
    },
    async openFeedback() {
      if (this.supportNotificationCount) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/notifications/readAll?type=11`)
      }


      this.radio = 1
      await this.loadList()
      this.$refs['feedbackReports'].open()
    },
    async loadList() {
      let loader = this.$loading.show()
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.post(`/api/v1/feedback/list${this.radio === 2 ? '-archived': ''}?companyId=${this.$route.query.companyId}&page=${this.page}`)
        this.tableData = data.list
        this.total = data.feedbackCount
      } catch (error) {
        console.log(error)
      } finally {
        loader.hide()
      }
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      // const { data } = await axios.post(`/api/v1/feedback/list?companyId=${this.$route.query.companyId}&page=${this.page}`)
      // axios.post(`/api/v1/feedback/list?companyId=${this.$route.query.companyId}&page=${this.page}`)
      //   .then(response => {
      //     console.log('---/feedback/list', response.data.list);
      //     this.tableData = response.data.list
      //     this.total = response.data.feedbackCount
      //     this.$refs['feedbackReports'].open()
      //     loader.hide()
      //   })
      //   .catch(error => {
      //     console.log('An error occurred:', error);
      //     loader.hide()
      //   })
    },
    handleCurrentChange(val) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/feedback/list${this.radio === 2 ? '-archived': ''}?companyId=${this.$route.query.companyId}&page=${val}`)
        .then(response => {
          console.log('---/feedback/list', response.data.list);
          this.tableData = response.data.list
          this.total = response.data.feedbackCount
          this.$refs['feedbackReports'].open()
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        })
    },
    closeModal() {
      this.page = 1
    },
    myProfile() {
      // TODO
      this.$router.push(`/users?companyId=${this.$route.query.companyId}&companyUserId=${this.user.user.id}`);
      // this.$emit('profile')

      // Log users
      log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
        'action': 'log_users',
        'paramsLog': {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.notification__item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  color: white;
  border-radius: 3px;
  margin-right: 3px;
  cursor: pointer;
}

/deep/.el-button--small, .el-button--small.is-round {
  padding: 5px 5px;
}

.link{
  color:#606260 !important;
}

.modal {
  color: #000;
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}

// [ Modal ] start
.button{
  cursor: pointer;
}
// [ Modal ] end

.confirmation-modal{
  color:black;
}
</style>

<style lang="scss">
.img {
  p {
    img {
      max-width: 100%;
    }
  }
}
</style>
